import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggler', 'togglee']

  togglerTargetConnected = (element) => {
    element.addEventListener('click', () => this.trigger())
  }

  connect = () => {
    document.addEventListener('click', event => this.checkClick(event))
  }

  open = () => {
    this.enter(this.toggleeTarget)
  }

  close = () => {
    this.leave(this.toggleeTarget)
  }

  trigger = () => {
    this.perform(this.toggleeTarget)
  }

  checkClick = (event) => {
    if (this.canClose(event)) {
      this.trigger()
    }
  }

  canClose = (event) => {
    return !event.target.closest('[data-transitions-target="togglee"]')
      && !event.target.closest('[data-transitions-target="toggler"]')
      && !this.closed
  }

  async enter(element, transitionName = null) {
    element.classList.remove('hidden')
    await this.transition('enter', element, transitionName)
  }

  async leave(element, transitionName = null) {
    await this.transition('leave', element, transitionName)
    element.classList.add('hidden')
  }

  async perform(element, transitionName = null) {
    if (this.closed) {
      await this.enter(element, transitionName)
    }
    else {
      await this.leave(element, transitionName)
    }
  }

  async transition(direction, element, animation) {
    const dataset = this.toggleeTarget.dataset
    const animationClass = animation ? `${animation}-${direction}` : direction
    const transition = `transition${direction.charAt(0).toUpperCase() + direction.slice(1)}`
    const genesis = dataset[transition] ? dataset[transition].split(' ') : [animationClass]
    const start = dataset[`${transition}Start`] ? dataset[`${transition}Start`].split(' ') : [`${animationClass}-start`]
    const end = dataset[`${transition}End`] ? dataset[`${transition}End`].split(' ') : [`${animationClass}-end`]

    this.addClasses(element, genesis)
    this.addClasses(element, start)
    await this.nextFrame()
    this.removeClasses(element, start)
    this.addClasses(element, end)
    await this.afterTransition(element)
    this.removeClasses(element, end)
    this.removeClasses(element, genesis)
  }

  addClasses = (element, classes) => {
    element.classList.add(...classes)
  }

  removeClasses = (element, classes) => {
    element.classList.remove(...classes)
  }

  nextFrame = () => {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve)
      })
    })
  }

  afterTransition(element) {
    return new Promise((resolve) => {
      // safari return string with comma separate values
      const computedDuration = getComputedStyle(element).transitionDuration.split(',')[0]
      const duration = Number(computedDuration.replace('s', '')) * 1000
      setTimeout(() => {
        resolve()
      }, duration)
    })
  }

  get closed() {
    return this.toggleeTarget.classList.contains('hidden')
  }
}
